import { AlertTriangle, ArrowRight } from "lucide-react";

/** One-line dashboard nudge that links straight to whatever still blocks
 *  real registrations. Renders nothing once the engine is ready. */
export const ReadinessBanner = ({ status }) => {
  if (!status || status.ready_to_register) return null;

  const token = status.transip_token || {};
  const missing = status.contact_missing || [];
  const blockers = [];

  if (!status.transip_configured) {
    blockers.push({ text: "TransIP credentials not set", href: "/settings?cat=registrars" });
  } else if (token.present && token.expired) {
    blockers.push({
      text: `TransIP token expired${token.expires_at ? ` (${token.expires_at.slice(0, 10)})` : ""}`,
      href: "/settings?cat=registrars",
    });
  } else if (!token.present) {
    blockers.push({ text: "TransIP token missing", href: "/settings?cat=registrars" });
  }

  if (missing.length > 0) {
    const pretty = missing
      .map((k) => k.replace("CONTACT_", "").replace(/_/g, " ").toLowerCase())
      .join(", ");
    blockers.push({ text: `Contact profile incomplete — need: ${pretty}`, href: "/settings?cat=contact" });
  }

  if (blockers.length === 0) return null;
  const primary = blockers[0];

  return (
    <a
      href={primary.href}
      data-testid="readiness-banner"
      className="flex items-center gap-2 px-6 py-2.5 bg-[#FEF3C7] border-b border-[#FDE68A] text-[#92400E] text-xs hover:bg-[#FDE68A] transition-colors"
    >
      <AlertTriangle className="w-3.5 h-3.5 shrink-0" strokeWidth={1.8} />
      <span className="font-medium">Snipes won't register for real yet:</span>
      <span className="truncate">
        {blockers.map((b) => b.text).join("  ·  ")}
      </span>
      <span className="ml-auto flex items-center gap-1 font-medium shrink-0 underline">
        Fix it <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.8} />
      </span>
    </a>
  );
};

export default ReadinessBanner;
